export default "__VITE_ASSET__46d18872__"